<img [src]="GetAssetImageLink(_user.iconHash)" class="inline-block rounded-md object-cover aspect-square {{_size}} max-w-min drop-shadow-lg"
     onerror="this.onerror=null;this.src='/assets/missingUser.svg';" [alt]="_user.username">
